<template>
    <td-dialog :visible.sync="copyTemplateDialogVisible" :title="$t('pgCommon.COPY_TEMPLATE')" :before-close="cancel" :close-on-click-modal="false" width="350px">
        <span style="margin-right: 20px;">{{ $t('pgCommon.PLEASE_SELECT_TEMPLATE') }}</span>
        <td-select style="margin-top: 10px;" keys="taskKey" text="taskName" :options="options" v-model="modelTaskKey"> </td-select>
        <span slot="footer">
            <td-button type="primary" @click="save" :loading="loading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    created() {
        this.getNodeInfo();
    },
    data() {
        return {
            loading: false,
            modelTaskKey: '',
            options: []
        };
    },
    props: {
        templateKey: {
            type: String
        },
        copyTemplateDialogVisible: {
            type: Boolean
        },
        nodetableData: {
            type: Array
        },
        btnCopyTemplateInfo: {
            type: Object
        }
    },
    methods: {
        save() {
            if (this.modelTaskKey == '') {
                this.$message({
                    message: this.$t('pgCommon.PLEASE_SELECT_TEMPLATE'),
                    type: 'warning'
                });
                return;
            }
            let tempInitGroupSid = this.templateKey + ':TEMP:' + this.btnCopyTemplateInfo.taskKey;
            let tempPsaaGroupSid = this.templateKey + ':TEMP:' + this.modelTaskKey;
            let tempPsaaGroupsName = '';
            for (let i = 0; i < this.nodetableData.length; i++) {
                if (this.modelTaskKey == this.nodetableData[i].taskKey) {
                    tempPsaaGroupsName = this.nodetableData[i].taskName;
                }
            }
            let param = {
                initiativeTabExtendGroupSid: tempInitGroupSid,
                initiativeTabExtendGroupsName: this.btnCopyTemplateInfo.taskName,
                psaaivityTabExtendGroupSid: tempPsaaGroupSid,
                psaaivityTabExtendGroupsName: tempPsaaGroupsName
            };
            api.copyTemplate(param, response => {
                this.loading = true;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: response.data.message });
                    this.loading = false;
                    this.$log.error('templateManage/copyTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('templateManage/copyTemplate', response.data.message);
                    return;
                }
                this.loading = false;
                this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.COPY_TEMPLATE_SUCCESS') });
                this.cancel();
            });
        },
        getNodeInfo() {
            let tempOptions = [];
            for (let i = 0; i < this.nodetableData.length; i++) {
                if (this.nodetableData[i].taskKey != this.btnCopyTemplateInfo.taskKey) {
                    tempOptions.push(this.nodetableData[i]);
                }
            }
            this.options = tempOptions;
        },
        cancel() {
            this.$emit('copyTemplateDialogColse');
        }
    }
};
</script>
